import withNavigate from "../../../routes/withNavigate.jsx";
import AdvanceSearchContainer from "./AdvanceSearchContainer.jsx";
import AdvanceSearchStore from "./AdvanceSearchStore.js";

export default AdvanceSearchStore(withNavigate(AdvanceSearchContainer));